"use client";

import { useTranslation } from "~/app/hooks/useTranslation";
import useLocalizedHref from "~/app/hooks/useLocalizedHref";
import { companyDetails, companyPhone } from "~/common/config/companyContact";
import JoinUsSection from "~/common/components/JoinUsSection";
import SectionFAQ from "~/common/components/SectionFAQ";
import { getPageFaqContent } from "~/common/data/faqPageData";

import SectionWrapper from "../../../common/components/SectionWrapper";

import KeepInTouchSection1 from "./components/KeepInTouchSection1";
import KeepInTouchSection2 from "./components/KeepInTouchSection2";
import styles from "./page.module.scss";
import legalStyles from "../delivery-and-returns/page.module.scss";

export default function KeepInTouch() {
  const { t } = useTranslation();
  const { locale, buildHref } = useLocalizedHref();
  const tr = locale === "tr";
  const faq = getPageFaqContent(t, "keepInTouch");

  return (
    <main className={styles.container}>
      <SectionWrapper className={`${styles.section1} contact-brand-hero`} background={"/assets/original/hero9-bg.8226df36.svg"}>
        <KeepInTouchSection1 />
      </SectionWrapper>

      <SectionWrapper className={styles.section2} background={"/keepInTouch/hero2.svg"}>
        <KeepInTouchSection2 />
      </SectionWrapper>
      <section className={legalStyles.policy} aria-labelledby="contact-company-title">
        <h2 id="contact-company-title">{tr ? "Şirket ve iletişim bilgileri" : "Company and contact details"}</h2>
        <dl className={legalStyles.details}>
          <div><dt>{tr ? "Ticaret unvanı" : "Registered company name"}</dt><dd>{companyDetails.name}</dd></div>
          <div><dt>{tr ? "Marka" : "Brand"}</dt><dd>{companyDetails.brand}</dd></div>
          <div><dt>{tr ? "İş yeri adresi" : "Registered business address"}</dt><dd>{companyDetails.address}</dd></div>
          <div><dt>{tr ? "Vergi dairesi / Vergi kimlik numarası" : "Tax office / Tax identification number"}</dt><dd>{companyDetails.taxOffice} / {companyDetails.taxNumber}</dd></div>
          <div><dt>{tr ? "MERSİS numarası" : "MERSIS number"}</dt><dd>{companyDetails.mersisNumber}</dd></div>
          <div><dt>{tr ? "KEP adresi" : "Registered electronic mail (KEP)"}</dt><dd>{companyDetails.kepEmail}</dd></div>
          <div><dt>{tr ? "Kayıtlı olunan oda" : "Chamber membership"}</dt><dd><a href={companyDetails.chamberUrl}>{companyDetails.chamberName}</a></dd></div>
          <div><dt>{tr ? "Oda mevzuatı" : "Chamber regulations"}</dt><dd><a href={companyDetails.chamberRegulationsUrl}>{tr ? "İTO Oda Mevzuatı" : "Istanbul Chamber of Commerce regulations"}</a></dd></div>
          <div><dt>{tr ? "Telefon" : "Phone"}</dt><dd><a href={companyPhone.href}>{companyPhone.display}</a></dd></div>
          <div><dt>{tr ? "Faturalandırma, iptal ve iade talepleri" : "Billing, cancellation and refund requests"}</dt><dd><a href={`mailto:${companyDetails.email}`}>{companyDetails.email}</a></dd></div>
        </dl>
        <p><a href={buildHref("company-information")}>{tr ? "Tüm şirket bilgileri" : "All company information"}</a></p>
        <p><a href={buildHref("distance-sales-agreement")}>{tr ? "Mesafeli Satış Sözleşmesi" : "Distance Sales Agreement"}</a></p>
      </section>
      {faq && <SectionFAQ title={faq.title} description={faq.description} faqData={faq.faqData} />}

      <SectionWrapper className={styles.section3}>
        <JoinUsSection
          imageSrc={"/about/banner.png"}
          title={t("keepInTouch.joinUsSection.title")}
          description={t("keepInTouch.joinUsSection.description")}
          buttonText={t("keepInTouch.joinUsSection.buttonText")}
          buttonProps={{
            action: "postText",
            actionArgs: [
              t("chatbot.startMessage.viewOpenRoles"),
              {
                start_intent_id: 41130,
              },
            ],
          }}
        />
      </SectionWrapper>
    </main>
  );
}


